import router from '../router'

let routesCopy = [] as any
// 拷贝一份菜单
routesCopy = JSON.parse(JSON.stringify(router.options.routes))

export const menulist = routesCopy
